import {Component} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import * as fromRoot from '../../../common/reducers';
import * as auth from '../../../common/actions/authentication';
import {Store} from '@ngrx/store';
import * as fromUtility from 'app/common/services/Utility.service';
import {EvsAuthenticationService} from '../../../common/services/EvsAuthentication.service';
import {FlashMessagesService} from 'angular2-flash-messages';
declare var $:any;

// import { AuthGuard } from 'app/common/services/Auth.guard';

/**
 * This class represents the lazy loaded HomeComponent.
 */

@Component({
    selector: 'sd-login',
    templateUrl: 'login-v3.component.html',
    providers: [EvsAuthenticationService]
})

export class LoginComponent {

    datas: any = [];
    loginForm: FormGroup;
    model: any = {};

    constructor(private store: Store<fromRoot.State>,
                private authEvs: EvsAuthenticationService,
                private flash: FlashMessagesService,
                private router: Router) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add("animsition");   //add the class
        // body.classList.add("page-login-v2");   //add the class
        // body.classList.add("page-login-v3");   //add the class
        body.classList.add("layout-full");   //add the class
        // body.classList.add("page-dark");   //add the class
    }

    authenticate(provider: string) {
        this.store.dispatch(new auth.LoginAction({provider: provider}))
    }

    ngOnInit() {
        if (!localStorage.getItem('Access-Token') || !localStorage.getItem('Access-Token-Icheck')) {
            localStorage.clear();
            this.router.navigate(['/login']);
        } else {
            this.router.navigate(['/'])
        }
    }

    OpenLink(route?: string, id?: string) {
        var Link = fromUtility.UtilityService.route(route, id);
        return Link;
    }

    onSubmit(data) {
        let mUser = {
            email: data.email ? data.email.trim() : '',
            // email: data.email,
            password: data.password,
            // domain: data.domain,
            domain: data.domain ? data.domain.trim() : '',
            ttl_in_second: 86400 * 3
        };
        this.store.dispatch(new auth.LoginAction(mUser));
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/auth/login.component.ts